import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import isMobile from '~/utils/is-mobile';

import font from '~/styled/font';
import btnStd from '~/styled/button';

function hover(color) {
  if (isMobile.any()) return '';
  return css`
    &:hover {
      background-color: ${color};
    }
  `;
}

function getColor(color) {
  switch (color) {
    case 'blue':
      return css`
        color: #326CF9;
        border: 1px solid #326CF9;
        ${hover('#EEF8FF')};
      `;

    case 'red':
      return css`
        color: #E20724;
        border: 1px solid #E20724;
        ${hover('#FFF4F4')};
      `;

    case 'gray':
      return css`
        color: #222222;
        border: 1px solid #DFDFDF;
        ${hover('#FAFAFA')};
      `;
  }

  return '';
}

function getSize(size) {
  switch (size) {
    case 'sm':
      return css`
        height: 28px;
        ${font.caption1};
      `;

    case 'md':
      return css`
        height: 36px;
        ${font.body3};
      `;

    case 'lg':
      return css`
        height: 44px;
        ${font.body3};
      `;

    case 'xl':
      return css`
        height: 56px;
        ${font.body3};
      `;
  }

  return '';
}

const LineButton = styled.button`
  ${btnStd};
  width: ${({ contentWidth }) => contentWidth};
  padding: 0 16px;
  font-weight: 700;
  background-color: #FFFFFF;
  
  > svg + span,
  > span + svg{
    margin-left: 4px;
  }
  
  ${({ btnColor }) => getColor(btnColor)};
  ${({ btnSize }) => getSize(btnSize)};

  &:disabled {
    color: #CCCCCC;
    border-color: #DFDFDF;
    background-color: #FAFAFA;

    > svg {
      path,
      circle,
      rect {
        fill: #CCCCCC !important;
      }
    }
  }
`;

const LineButtonComponent = forwardRef(({
  contentWidth = 'auto',
  btnColor,
  btnSize,
  iconName,
  children,
  ...props
}, ref) => {
  return (
    <LineButton
      {...props}
      ref={ref}
      btnColor={btnColor}
      btnSize={btnSize}
      contentWidth={contentWidth}
    >
      <span>{children}</span>
    </LineButton>
  );
});

export default LineButtonComponent;
